import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import messages from '../translations/messages'
import NotificationHandler from './components/utils/NotificationHandler'
import Toaster from './components/utils/Toaster.vue'
import VueGoogleCharts from 'vue-google-charts'
import getSymbolFromCurrency from 'currency-symbol-map'
import VueContentPlaceholders from 'vue-content-placeholders'

document.title = 'Stellantis MAT Evo'

Vue.config.productionTip = false

Vue.filter('formatDate', function (value, dateFormat) {
  if (value) {
    return moment(value).format(dateFormat)
  }
})

Vue.filter('formatPrice', function (value, offerType, currency) {
  let formattedPrice = ''
  if (value && offerType) {
    switch (offerType) {
      case 'percentage':
        formattedPrice = `${value}%`
        break
      case 'number': {
        formattedPrice = `${value}${getSymbolFromCurrency(currency)}`
      }
    }
  }
  return formattedPrice
})

Vue.filter('localizedNumber', (value, locale) => {
  if (value !== undefined && value !== null) {
    return value.toLocaleString(locale)
  } else {
    return ''
  }
})

Vue.filter('capitalize', value => {
  if (value) {
    return value.replace(/^\w/, c => c.toUpperCase())
  } else {
    return '\xa0'
  }
})

Vue.filter('asTwoDigits', value => {
  if (!value) {
    return '00'
  }
  const number = parseInt(value)
  if (number === 0) {
    return '00'
  } else if (number > 0 && number <= 9) {
    return `0${number}`
  } else {
    return `${value}`
  }
})

Vue.filter('highlight', function (word, query) {
  if (word) {
    const regexp = new RegExp(query, "ig");
    return word.replace(regexp, matchedText => `<mark>${matchedText}</mark>`)
  } else {
    return word
  }
});

Vue.directive('click-outside', {
  bind (el, binding, vnode) {
    const vm = vnode.context
    const callback = binding.value.callback
    const enable = binding.value.enable

    if (enable) {
      el.clickOutsideEvent = function (event) {
        if (!(el === event.target || el.contains(event.target))) {
          return callback.call(vm, event)
        }
      }
      document.body.addEventListener('click', el.clickOutsideEvent)
    }
  },
  unbind (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

Vue.mixin(NotificationHandler)
Vue.mixin(Toaster)
Vue.use(VueGoogleCharts)
Vue.use(VueI18n)
Vue.use(VueContentPlaceholders)

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
